var exports = {
  "k": "xe7b6e3d6--9d8891--container",
};

module.exports = exports;
